export default __webpack_public_path__ + "static/metaPartnerIcon-2fac6854514911d6fa897389667dfac1.svg";